export default class ExternalScriptLoader {
    public static loadSnitcherScript(code: string | null) {
        if (!code) {
            return;
        }

        this.load(`
        !function(s,n,i,t,c,h){s.SnitchObject=i;s[i]||(s[i]=function(){
    (s[i].q=s[i].q||[]).push(arguments)});s[i].l=+new Date;c=n.createElement(t);
    h=n.getElementsByTagName(t)[0];c.src='//snid.snitcher.com/${code}.js';
    h.parentNode.insertBefore(c,h)}(window,document,'snid','script');
        
    snid('verify', '${code}');
        `
        );
    }

    public static load(scriptContent: string, callback?: () => void) {
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.async = true;
        script.defer = true;
        script.text = scriptContent;

        script.onload = () => {
            if (callback) callback();
        };

        script.onerror = () => {
            console.error('Failed to inject script content');
        };

        document.head.appendChild(script);
    }
}